import { createFileRoute } from '@tanstack/react-router';

import { PaymentPage } from '../../portal/payment-page';

/** `/account/payment` — the card on file (M10.5, FR-PAY-08). */
export const Route = createFileRoute('/account/payment')({
  component: PaymentPage,
});
